import Vuex from 'vuex'
import Vue from 'vue'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'security-store',
  storage: localStorage
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    claims: [],
    expirationDate: null,
    isAuth: false,
    userType: null
  },
  getters: {
    claims: (state) => state.claims,
    expirationDate: (state) => state.expirationDate,
    isAuth: (state) => state.isAuth,
    userType: (state) => state.userType
  },
  mutations: {
    setClaims (state, newClaims) {
      state.claims = newClaims
    },
    setUserType (state, userType) {
      state.userType = userType
    },
    setExpirationDate (state, newDate) {
      state.expirationDate = newDate
    },
    setIsAuth (state) {
      state.isAuth = true
    },
    unsetIsAuth (state) {
      state.isAuth = false
    }
  },
  actions: {
    setClaims (context, newClaims) {
      context.commit('setClaims', newClaims)
    },
    setExpirationDate (context, newDate) {
      context.commit('setExpirationDate', newDate)
    },
    setIsAuth (context) {
      context.commit('setIsAuth')
    },
    unsetIsAuth (context) {
      context.commit('unsetIsAuth')
    },
    setUserType (context, userType) {
      context.commit('setUserType', userType)
    }
  }
})
